 
import CONSTANT from '../constant/topic'
import service from '../service/topic'
import STATUS_CODE from '../constant/status_code'


export default {
  getTopicItems({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getTopicItems(data).then(result => {
        if(result === STATUS_CODE.ACTIVITY_OUT_LINE || result === STATUS_CODE.ACTIVITY_OUT_TIME){
          commit(CONSTANT.TOPIC_ACTIVITY_OUT)
          return resolve('')
        }
        commit(CONSTANT.TOPIC_GET_LIST_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.TOPIC_GET_LIST_ERROR, e)
        reject(e)
      })
    })
  },
  getTopicItemsMore({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getTopicItems(data).then(result => {
        if(result === STATUS_CODE.ACTIVITY_OUT_LINE || result === STATUS_CODE.ACTIVITY_OUT_TIME){
          commit(CONSTANT.TOPIC_ACTIVITY_OUT)
          return resolve('')
        }
        commit(CONSTANT.TOPIC_GET_LIST_MORE_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.TOPIC_GET_LIST_MORE_ERROR, e)
        reject(e)
      })
    })
  },
  getTopicBillboards({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getTopicBillboards(data).then(result => {
        commit(CONSTANT.TOPIC_BILLBOARDS_GET_LIST_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.TOPIC_BILLBOARDS_GET_LIST_ERROR, e)
        reject(e)
      })
    })
  }
}